import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="mb-0 text-center">
        <div className="d-flex align-items-center justify-content-center pb-5">
          {/* <div className="col-md-6">
            <p className="mb-3 mb-md-0">Made with ❤️ by {" "}
              <a  href="https://sahibsingh.dev" className="text-decoration-underline text-dark fs-5" target="_blank" rel="noreferrer">Sahib Singh</a>
            </p>
            <a className="text-dark fs-4" href="https://github.com/ssahibsingh" target="_blank" rel="noreferrer">
              <i className="fa fa-github"></i>
            </a>
          </div> */}

          <div className="col-md-6">
            <p className="mb-3 mb-md-0">
              All rights reserved. Copyright © 2025, ZENFURA
              {/* <a  href="https://sahibsingh.dev" className="text-decoration-underline text-dark fs-5" target="_blank" rel="noreferrer">Sahib Singh</a> */}
            </p>
            <a href="https://zenfura.com/terms.html" target="_blank" rel="noreferrer" style={{ color: 'black' }}>
              Terms and conditions
            </a>< br />
            <p>Email: info@zenfura.com</p>
            {/* <a
              className="text-dark fs-4"
              href="https://www.youtube.com/@Zen"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa fa-youtube" style={{ marginRight: '2%' }}></i>
            </a>
            <a
              className="text-dark fs-4"
              href="https://t.me/zenfura"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa fa-telegram" style={{ marginLeft: '2%' }}></i>
            </a> */}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
